import { useAtom, useSetAtom } from 'jotai';
import { Button } from '@mui/material';

import { isBackdropOpenAtom, snackbarPropsAtom } from '../../../atoms';
import { instrumentListVersionAtom } from '../../../atoms/instrumentAtoms';
import { ApiHardwares } from '../../../api/apiHardwares';
import { Dispatch, SetStateAction } from 'react';

const RegisterButton = (props: {
  serial: string;
  isSerialValid: boolean;
  code: string;
  isCodeValid: boolean;
  dealer: string;
  isDealerValid: boolean;
  setIsRegisterModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const {
    serial,
    isSerialValid,
    code,
    isCodeValid,
    dealer,
    isDealerValid,
    setIsRegisterModalOpen,
  } = props;
  const setIsBackdropOpen = useSetAtom(isBackdropOpenAtom);
  const setSnackbarProps = useSetAtom(snackbarPropsAtom);
  const [version, setVersion] = useAtom(instrumentListVersionAtom);

  const onClickRegistration = async () => {
    setIsRegisterModalOpen(false);
    setIsBackdropOpen(true);

    await ApiHardwares.post(serial, code, dealer)
      .then(() => {
        setVersion(version + 1);
        localStorage.setItem('latestInputDealer', dealer);
        setSnackbarProps({
          isOpen: true,
          message: '器械を登録しました。',
          type: 'success',
        });
      })
      .catch((error) => {
        console.log(error);
        setSnackbarProps({
          isOpen: true,
          message: '器械の登録に失敗しました。',
          type: 'error',
        });
      })
      .finally(() => {
        setIsBackdropOpen(false);
      });
  };

  const inputDataValidation = () => {
    return (
      serial !== '' &&
      isSerialValid &&
      code !== '' &&
      isCodeValid &&
      dealer !== '' &&
      isDealerValid
    );
  };

  return (
    <Button
      variant='contained'
      color={'primary'}
      sx={{ width: '150px' }}
      disabled={!inputDataValidation()}
      onClick={onClickRegistration}
    >
      {'決定'}
    </Button>
  );
};

export default RegisterButton;
